import { render, staticRenderFns } from "./segment.vue?vue&type=template&id=2f86b1b8&"
import script from "./segment.vue?vue&type=script&lang=js&"
export * from "./segment.vue?vue&type=script&lang=js&"
import style0 from "./segment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports